import React, { ReactNode, useEffect, useRef } from 'react';
import Header from '../../Header/CarelonRx';
import Banner from '../../Banner/CarelonRx';
import Footer from '../../Footer/CarelonRx';
import '../../../styles/CarelonRx/layout.css';

interface PageLayoutProps {
  bannerTitle: string;
  bannerSubtitle?: string;
  bannerContent?: ReactNode;
  footerContent?: ReactNode;
  children: ReactNode;
  showLogout?: boolean;
  onLogout?: () => void;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  bannerTitle,
  bannerSubtitle,
  bannerContent,
  footerContent,
  children,
  showLogout = false,
  onLogout
}) => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollY = useRef(0);
  const locked = useRef(false);

  useEffect(() => {
    const MODAL_SELECTORS = ['.modal-overlay', '.incorrect-ou-modal-overlay'];

    const applyScrollLock = () => {
      const isModalOpen = MODAL_SELECTORS.some(
        (sel) => document.querySelector(sel) !== null
      );

      if (isModalOpen && !locked.current) {
        scrollY.current = window.scrollY;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY.current}px`;
        document.body.style.width = '100%';
        locked.current = true;
      } else if (!isModalOpen && locked.current) {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY.current);
        locked.current = false;
      }
    };

    const observer = new MutationObserver(applyScrollLock);
    observer.observe(document.body, { childList: true, subtree: true });
    applyScrollLock();

    return () => {
      observer.disconnect();
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    };
  }, []);

  return (
    <div className="page-layout">
      <Header showLogout={showLogout} onLogout={onLogout} />
      <Banner title={bannerTitle} subtitle={bannerSubtitle}>
        {bannerContent}
      </Banner>
      <main className="page-content">
        {children}
      </main>
      <Footer>{footerContent}</Footer>
    </div>
  );
};

export default PageLayout;
